import React from 'react';
import { Grid, Chip, Stack, Button } from '@mui/material';
import useStore from '../../store/useStore';
import { Close } from '@carbon/icons-react';
const FilterChipsEvents = () => {
    const { filters, setFilter } = useStore((state: any) => ({
        filters: state.filters,
        setFilter: state.setFilter,
    }));

    function renderSwitch(param: any) {
        //console.log(param)
        switch (param) {
            case 'SectorEvent':
                return 'Sector';
            case 'Types':
                return 'Type';
            case 'MeetingGroup':
                return 'Group';
            case 'Formats':
                return 'Format';
            case 'SectorGroups':
                return 'Group';
            case 'searchEvent':
                return 'Keyword(s)';


            default:
                return param;
        }
    }


    const filtersarray = ['searchEvent', 'SectorEvent', 'Types', 'MeetingGroup', 'Formats', 'SectorGroups'];

    //reset all state filters
    function resetAllFilters() {
        filtersarray.map((filter) => {
            setFilter(filter, '')
        })
    }

    return (
        <div style={{ width: '100%', margin: '1rem auto 0' }}>
            <div className='ituContainer' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>

                    <p style={{ marginRight: '0.5rem' }}>Filtered by:</p>
                    {filtersarray.map((filter) => {
                        //console.log(typeof filters[filter as keyof typeof filters])
                        //console.log(filter + filters[filter as keyof typeof filters])
                        //console.log(filter + filters[filter as keyof typeof filters] + strLength)
                        let strLength: number =0;
                        if( filters[filter as keyof typeof filters]) 
                        strLength=filters[filter as keyof typeof filters].length

                        if (filters[filter as keyof typeof filters] !== '' && strLength > 0) {
                            return (
                                <Chip
                                    key={filter}
                                    variant="outlined"
                                    deleteIcon={<Close/>}
                                    style={{ border: "2px solid #007FAD", borderRadius: "4px", color: "#007FAD", marginRight: '0.5rem' }}
                                    label={`${renderSwitch(filter)
                                        }: ${filters[filter as keyof typeof filters]}`}
                                    onDelete={() => setFilter(filter, '')}
                                />
                            );
                        }

                    })}
                </div>
                <div>
                    <Button
                        variant="text"
                        endIcon={<Close />}
                        style={{ color: '#6E6E6E', border: "2px solid transparent" }}
                        onClick={() => resetAllFilters()}

                    >
                        Reset all filters
                    </Button>
                </div>
            </div>
        </div>

    );
};

export default FilterChipsEvents;

